
import moment from 'moment'
export default {
  methods: {
    formDate(value) {
      if (value && moment(value).isValid()) {
        return moment(value).format('DD.MM.YYYY')
      } else {
        return ''
      }
    },
    date_to(item, ) {
      let setDate = (date) => {
        if (date && moment(date).isValid()) {
          let formatted = +moment(date).format('HHmm') > 0 ?
            moment(date).format('DD.MM.YYYY HH:mm')
            :  moment(date).format('DD.MM.YYYY')
          return this.$t('Common.till') + ' ' + formatted
        }
      }
      return setDate(item.dateUnlock ) ||  setDate(item.dateTo ) || this.$t('StopLists.Permanently')
    },
    close(condition) {
      if ( this.$route?.query?.from && !condition) {
        this.$router.push({name: 'tenderitem', params: {org: this.$route.params.org, id: this.$route?.query?.from} })
      } else {
        this.$router.push({name: 'stopLists', params: {org: this.$route.params.org} })
      }
    },
    setStatus(obj = {}) {
      let blocked = obj.status == 'E' || obj.actualStatus == 'E'
      obj.status_name = blocked ? this.$t('StopLists.IsBlocked') : this.$t('StopLists.Isnlocked')
      obj.status_key = blocked ? 'Execution' : 'Cancel'
    }
  },
  computed: {
  }
}
